export const MONITORING_JOBS_BASE_PATH = '/monitoring-job';
